import Formula from '../views/ProyectosConfig/Presupuesto_Formula/Edit.js';
import Edit from '../views/Configuraciones/Edit.js';
import ModalBackup from '../views/Config/Backup/ModalBackup.js';

export default {
	items: [
		{
			name: 'Proyectos',
			icon: 'fa fa-file-text-o',
			url: '/proyectos/',
			children: [
				{
					name: 'Gestión Previa',
					url: '/proyectos/gestion/',
					icon: 'fa fa-phone',
					permission: 'gestionprevia_view'
				},
				{
					name: 'Solicitudes',
					url: '/proyectos/solicitudes/',
					icon: 'fa fa-user-plus',
					permission: 'solicitudes_view'
				},
				{
					name: 'Plan de Trabajo',
					url: '/proyectos/planes/',
					icon: 'fa fa-play',
					permission: 'plandetrabajo_view'
				},
				{
					name: 'Presupuestación',
					url: '/proyectos/presupuestos/',
					icon: 'fa fa-usd',
					permission: 'presupuestos_view'
				},
				{
					name: 'Informes',
					url: '/proyectos/informes/',
					icon: 'fa fa-file-o',
					permission: 'informes_view'
				},
				{
					name: 'Certificación',
					url: '/proyectos/certificacion/',
					icon: 'fa fa-list',
					permission: 'certificacion_view'
				},
				{
					name: 'Informe al Cliente',
					url: '/proyectos/informealcliente/',
					icon: 'fa fa-envelope',
					permission: 'sendemail_view'
				},
			]
		},
		{
			name: 'Imputaciones',
			icon: 'fa fa-area-chart',
			// url: '/reportes/',
			children: [
				{
					name: 'Distribución', //'Imputaciones',
					url: '/imputaciones/imputaciones/',
					icon: 'fa fa-list-alt',
					permission: 'imputaciones_imputaciones_view'
				},
				{
					name: 'Parámetros',
					url: '/imputaciones/parametros/',
					icon: 'fa fa-bandcamp',
					permission: 'imputaciones_parametros_view'
				},
				 {
				 	name: 'Gestión Productividad',
				 	url: '/imputaciones/gestionproductividad/',
				 	icon: 'fa fa-pie-chart',
				 	permission: 'imputaciones_gestionproductividad_tabla'
				 },
			]
		},
		{
			name: 'Convenios',
			icon: 'fa fa-handshake-o',
			url: '/convenios/',
			permission: 'convenios_view',
			children: [
				{
					name: 'Convenios',
					url: '/convenios/convenios/',
					icon: 'fa fa-handshake-o',
					permission: 'convenios_view'
				},
				{
					name: 'Tipos',
					url: '/convenios/tipos/',
					icon: 'fa fa-bandcamp',
					permission: 'convenios_view'
				},
				{
					name: 'Dependencias',
					url: '/convenios/dependencias/',
					icon: 'fa fa-list-alt',
					permission: 'convenios_view'
				},
			]
		},
		{
			name: 'Indicadores',
			icon: 'fa fa-book',
			url: '/indicadores/',
			children: [
				{
					name: 'Facturación',
					url: '/indicadores/facturacion/',
					icon: 'fa fa-money',
					permission: 'reportes_facturacion_view'
				},
				{
					name: 'Estadísticas',
					url: '/indicadores/estadisticas/',
					icon: 'fa fa-line-chart',
					permission: 'reportes_estadisticas_view'
				},
				{
					name: 'Proyectos',
					url: '/indicadores/visualizadorproyectos/',
					icon: 'fa fa-eye',
					permission: 'reportes_individual_view'
				},
				{
					name: 'Proyectos por Estado',
					url: '/indicadores/visualizadorglobal/',
					icon: 'fa fa-eye',
					permission: 'reportes_global_view'
				}
			]
		},
		// {
		// 	name: 'Tutoriales',
		// 	url: '/tutoriales/',
		// 	icon: 'fa fa-book',
		// 	permission: 'superadmin'
		// },
		{
			name: 'Consultas',
			icon: 'fa fa-search',
			url: '/consultas/',
			children: [
				{
					name: 'Participación',
					url: '/consultas/certificacion/',
					icon: 'fa fa-file',
					permission: 'consultas_participacion_view'
				},
				{
					name: 'Productividad',
					url: '/consultas/productividad/',
					icon: 'fa fa-pie-chart',
					permission: 'consultas_productividad_view'
				},
				{
					name: 'Convenios',
					url: '/consultas/convenios/',
					icon: 'fa fa-book',
					permission: 'consultas_convenios_view'
				},
				// {
				// 	name: 'Imputaciones',
				// 	url: '/consultas/imputaciones/',
				// 	icon: 'fa fa-file',
				// 	permission: 'consultas_participacion_view'
				// },
			]
		},
		{
			name: 'Clientes',
			icon: 'icon-people',
			url: '/clientes/',
			children: [
				{
					name: 'Contactos',
					url: '/clientes/contactos/',
					icon: 'fa fa-user',
					permission: 'responsables_view'
				},
				{
					name: 'Empresas/Org.',
					url: '/clientes/empresas/',
					icon: 'fa fa-building',
					permission: 'empresas_view'
				},
				{
					name: 'Rubros',
					url: '/clientes/rubros/',
					icon: 'fa fa-th-list',
					permission: 'rubros_view'
				},
				{
					name: 'Tipos de Empresas',
					url: '/clientes/clasificacionempresas/',
					icon: 'fa fa-th-list',
					permission: 'clasificacionempresas_view'
				},
			]
		},
		{
			name: 'Historicos',
			// icon: 'fa fa-history',
			icon: 'fa fa-header',
			url: '/historicos/',
			children: [
				{
					name: 'Proyectos',
					url: '/historicos/proyectosahistoricos/',
					icon: 'fa fa-folder-open',
					permission: 'historico_view'
				},
				{
					name: 'Historicos',
					url: '/historicos/proyectoshistoricos/',
					icon: 'fa fa-archive',
					permission: 'historico_view'
				},
			]
		},
		{
			name: 'Usuarios',
			icon: 'icon-user',
			url: '/usuarios/',
			children: [
				{
					name: 'Usuarios',
					url: '/usuarios/usuarios/',
					icon: 'fa fa-user',
					permission: 'usuarios_view'
				},
				{
					name: 'Grupos',
					url: '/usuarios/grupos/',
					icon: 'fa fa-users',
					permission: 'grupos_view'
				},
				{
					name: 'Subgrupos',
					url: '/usuarios/subgrupos/',
					icon: 'fa fa-users',
					permission: 'subgrupos_view'
				},
				{
					name: 'Perfiles de Usuario',
					url: '/usuarios/perfiles/',
					icon: 'fa fa-lock',
					permission: 'perfiles_view'
				},
				{
					name: 'Permisos',
					url: '/usuarios/permisos/',
					icon: 'fa fa-lock',
					permission: 'superadmin'
				},
			]
		},
		{
			name: 'Parámetros',
			icon: 'fa fa-file-text-o',
			url: '/proyectosconfig/',
			children: [
				{
					name: 'Plantillas',
					url: '/proyectosconfig/plantillas/',
					icon: 'fa fa-file-text',
					permission: 'plantillas_view'
				},
				{
					name: 'Certificación',
					icon: 'fa fa-list',
					url: '/proyectosconfig/certificacion/',
					children: [
						{
							name: 'Roles',
							url: '/proyectosconfig/certificacion/roles/',
							permission: 'rolessolicitud_view'
						},
						{
							name: 'Firmas',
							url: '/proyectosconfig/certificacion/firmas/',
							permission: 'firmas_view'
						},
					]
				},
				{
					name: 'Plan de Trabajo',
					icon: 'fa fa-play',
					url: '/proyectosconfig/plan/',
					children: [
						{
							name: 'Tipos de Transf.',
							url: '/proyectosconfig/plan/tipos/',
							permission: 'tiposdeplan_view'
						}, {
							name: 'Subtipos de Transf.',
							url: '/proyectosconfig/plan/subtipos/',
							permission: 'tiposdeplan_view'
						},
						{
							name: 'Modos de Vinculación',
							url: '/proyectosconfig/plan/modos/',
							permission: 'marcosdeplan_view'
						},
						{
							name: 'Campos del Plan',
							url: '/proyectosconfig/plan/campos/',
							permission: 'camposdeplan_view'
						},
					]
				},
				{
					name: 'Presupuesto',
					icon: 'fa fa-usd',
					url: '/proyectosconfig/presupuesto/',
					children: [
						{
							name: 'OTT - UVT',
							url: '/proyectosconfig/presupuesto/uvt/',
							permission: 'uvt_view'
						},
						{
							name: 'Moneda de Pago',
							url: '/proyectosconfig/presupuesto/monedas/',
							permission: 'condicionesdepago_view'
						},
						{
							name: 'Plazos',
							url: '/proyectosconfig/presupuesto/plazos/',
							permission: 'plazos_view'
						},
						{
							name: 'Tipos de Costo',
							url: '/proyectosconfig/presupuesto/tiposdecosto/',
							permission: 'tiposdecosto_view'
						},
						{
							name: 'Motivos de Rechazo',
							url: '/proyectosconfig/presupuesto/motivos/',
							permission: 'motivosderechazo_view'
						},
						{
							name: 'Coeficientes UE',
							url: '/proyectosconfig/presupuesto/coeficientesue/',
							permission: 'coeficientesue_view'
						},
						{
							name: 'Coeficientes GC',
							url: '/proyectosconfig/presupuesto/coeficientesgc/',
							permission: 'coeficientesgc_view'
						},
						{
							name: 'Fórmula',
							component: Formula,
							permission: 'formula_edit'
						},
					]
				},
			]
		},
		{
			name: 'Saldos',
			icon: 'fa fa-archive',
			children: [
				{
					name: 'Movimientos',
					icon: 'fa fa-money',
					url: '/saldos/movimientos/',
					permission: 'saldos_movimientos_view'
				},
				{
					name: 'Categorias',
					url: '/saldos/categorias/',
					icon: 'fa fa-th',
					permission: 'saldos_categorias_view'
				},
				{
					name: 'UVT',
					url: '/saldos/uvt/',
					icon: 'fa fa-th',
					permission: 'saldos_uvt_view'
				},
	]
		},
		{
			name: 'Configuración',
			icon: 'fa fa-cog',
			url: '/config/',
			children: [
				{
					name: 'General',
					icon: 'fa fa-cog',
					component: Edit,
					permission: 'config_general'
				},
				{
					name: 'Países',
					url: '/config/paises/',
					icon: 'fa fa-map',
					permission: 'pais_view'
				},
				{
					name: 'Mails',
					icon: 'fa fa-envelope',
					children: [
						{
							name: 'Casillas',
							url: '/config/email/casillas/',
							permission: 'config_email_casillas_view'
						},
						{
							name: 'Plantillas',
							url: '/config/email/plantillas/',
							permission: 'config_email_plantillas_view'
						}
					]
				},
				{
					name: 'Backup',
					// url: '/proyectosconfig/backup/backupdb/',
					component: ModalBackup,
					icon: 'fa fa-database',
					permission: 'pais_view'
				},
			]
		}
	]
};



// WEBPACK FOOTER //
// ./src/components/Menues.js